import { CircularProgress } from '@mui/material'
import clsx from 'clsx'
import { Input } from 'components/input'
import { Typography } from 'components/typography'
import { Icons, TagAudienceProps, TypographyTypes } from 'interfaces'
import React, { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { PRIMARY_BLUE_COLOR } from 'utils/constants'

export const TagAudience: React.FC<TagAudienceProps> = ({
	resetInput,
	handleChangeDebounce,
	setSearchTags,
	searchTags,
	isLoadingTagsAudience,
	dataTagsAudience,
	fetchNextPageTagsReach,
	hasNextPageTagsReach,
	isFetchingNextPageTagsReach
}) => {
	const { ref, inView } = useInView()

	useEffect(() => {
		if (
			inView &&
			hasNextPageTagsReach &&
			!isFetchingNextPageTagsReach &&
			!isLoadingTagsAudience
		) {
			fetchNextPageTagsReach?.()
		}
	}, [inView, isFetchingNextPageTagsReach])

	return (
		<div className="w-full flex flex-col items-center justify-center gap-4 py-4">
			<div className="w-full flex items-center justify-center">
				<Input
					rightClick={() => {
						resetInput()
						setSearchTags('')
					}}
					name="search"
					onChangeCustom={e => {
						setSearchTags(e.target.value)
						handleChangeDebounce(e)
					}}
					search
					className="w-full"
					placeholder="Search users"
					rightIcon={Icons.cancel}
					inputClassName="!p-[unset] !py-1 !px-2 !rounded-[16px]"
					inputFocus
					borderFull={false}
					value={searchTags}
				/>
			</div>
			{isLoadingTagsAudience ? (
				<div className="w-full flex flex-col h-[430px] items-center justify-center">
					<CircularProgress disableShrink />
				</div>
			) : (
				<>
					<div className="w-full flex items-center justify-start px-4">
						<Typography
							title="Name"
							type={TypographyTypes.h2}
							fontLeading="15/18"
							className="text-[#5A5A5A] !font-bold text-center"
						/>
					</div>
					<div className="overflow-y-auto h-[270px] w-full px-4 scrollbar-simple scrollbar-stable">
						<div className="w-full flex flex-col items-start justify-start gap-4">
							{dataTagsAudience?.pages.length === 0 ? (
								<div className="w-full flex items-center justify-center">
									<Typography
										title="No users found"
										type={TypographyTypes.h3}
										fontLeading="18/21"
										className="text-gray-1"
									/>
								</div>
							) : (
								dataTagsAudience?.pages
									.flatMap(pageReach => pageReach?.items)
									.map((user, index) => (
										<div
											key={index}
											className="flex flex-col overflow-x-hidden "
										>
											<Typography
												title={user?.name || ''}
												type={TypographyTypes.h2}
												fontLeading="15/18"
												className="text-[#5A5A5A] !font-normal "
											/>
										</div>
									))
							)}
						</div>
						<div
							ref={ref}
							className={clsx('w-full flex items-center justify-center')}
						>
							{isFetchingNextPageTagsReach && (
								<CircularProgress
									style={{ color: PRIMARY_BLUE_COLOR }}
									disableShrink
									size={30}
								/>
							)}
						</div>
					</div>
				</>
			)}
		</div>
	)
}
